<template>
  <Input
    id="search"
    v-model="modelValueInternal"
    type="search"
    size="md"
    :icon="MagnifyingGlassIcon"
    :placeholder="app.texts.filter.search"
  />
</template>

<script setup lang="ts">
import { app } from "@/app.context";
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { computed } from "vue";

const props = defineProps<{ modelValue?: string }>();
const emit = defineEmits<{
  (e: "update:modelValue", value: string | undefined): void;
}>();

const debounceModelValue = debounce((value: string | undefined) => {
  emit("update:modelValue", value);
}, 400);

const modelValueInternal = computed({
  get: () => props.modelValue,
  set: (value) => {
    debounceModelValue(value);
  },
});

function debounce<Args>(func: (...args: Args[]) => void, wait: number) {
  let timeout: ReturnType<typeof setTimeout>;
  return (...args: Args[]) => {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
</script>
